<div class="admin-synchronize">
  <button class="btn btn-primary pt-2 pb-2" (click)="synchronizePositions()">Synchronize positions</button>
  <button class="btn btn-primary pt-2 pb-2 ms-2" (click)="synchronizeAbsences()">Synchronize absences</button>
  <button class="btn btn-primary pt-2 pb-2 ms-2" (click)="synchronizeDailyPatterns()">Synchronize daily patterns</button>
  <button class="btn btn-primary pt-2 pb-2 ms-2" (click)="synchronizeContractHours()">Synchronize contract hours</button>
</div>